import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { encodeFilters, isValidArray } from "../../Layout/Common/common";
import { useCurrentRefinements } from "react-instantsearch";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";
import { ClearAllRefinement } from "../../Layout/Common/algoliaInstantLib";
import { PAGES } from "../../routeConfig";

export const SelectedFilterLite = ({ categoryRefine }) => {
  const { items, refine } = useCurrentRefinements();
  const [refinements, setRefinements] = useState(null);
  const [categoryMenu, setcategoryMenu] = useState(null);
  const [paramFilter, setParamFilter] = useState(null);
  const [onAppied, setOnAppied] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryDataAll } = useContext(GlobalContext);
  const history = useNavigate();
  useEffect(() => {
    if (isValidArray(items)) {
      var filteredItems = items.filter((i) => i.attribute != "categories.lvl0");
      var categoryItems = items.find((i) => i.attribute == "categories.lvl0");
      var refined = filteredItems.map((row) => {
        return {
          label: row.label.split(".").at(-1),
          attribute: row.label,
          refinements: row.refinements,
        };
      });
      setRefinements(refined);
      if (categoryItems) {
        var catValue = categoryItems.refinements[0].value;
        var catArray = catValue.split(">").map((item) => String(item).trim());
        var catRefineds = [];
        catArray.map((item, index) => {
          catRefineds.push({
            label: item,
            value: catArray.slice(0, index + 1).join(" > "),
          });
        });
        setcategoryMenu(catRefineds);
      }
      var params = {};
      refined.map((row) => {
        params[row.attribute] = [];
        row.refinements.map((val) => {
          params[row.attribute] = [...params[row.attribute], val.value];
        });
      });
      setOnAppied(true);
      setParamFilter(params);
    } else {
      setRefinements(null);
      setParamFilter(null);
    }
  }, [items]);

  useEffect(() => {
    try {
      var encodeparams = encodeFilters(paramFilter);
      const params = new URLSearchParams(location.search);
      const q = params.get("q");
      const f = params.get("f");
      var decodedFilter = encodeparams ? "f=" + encodeparams : null;

      // Build target URL and get current full URL for comparison
      let targetUrl = null;
      if (location.pathname.includes("/search") && decodedFilter) {
        targetUrl = "/search?q=" + encodeURIComponent(q) + "&" + decodedFilter;
      } else if (decodedFilter) {
        targetUrl = location.pathname + "?" + decodedFilter;
      } else if (!decodedFilter && !location.pathname.includes("/search")) {
        targetUrl = location.pathname;
      } else if (location.pathname.includes("/search") && f) {
        targetUrl = "/search?q=" + encodeURIComponent(q);
      }

      // Get current full URL for comparison
      const currentUrl = location.pathname + location.search;

      // Only navigate if target URL is different from current URL
      if (targetUrl && targetUrl !== currentUrl) {
        navigate(targetUrl, { replace: true });
      }
    } catch (e) {
      console.error("push url", e);
    }
  }, [paramFilter, navigate]);

  const handleRemoveCategory = (cat) => {
    try {
      if (!cat || !normizedString(cat).includes(">")) return;
      let catPaths = cat.split(" > ");
      catPaths.pop();
      const parentPath = catPaths.join(" > ");
      const filteredCat = categoryDataAll.find((i) => normizedString(i.eaPath) == normizedString(parentPath));
      if (filteredCat?.url) {
        window.history.replaceState(null, "", filteredCat.url);
      }
    } catch (e) {
      console.error("handleRemoveCategory error:", e);
    }
  };

  const normizedString = (path) => {
    try {
      return String(path).trim().toLowerCase();
    } catch (e) {
      return String(path).toLowerCase();
    }
  };
  return (
    <div className="accordion-item border-bottom mb-3" id="selectedfilterAccordion">
      <h2 className="accordion-header">
        <button
          className="accordion-button collapsed"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#selected-fitlers"
          aria-expanded="true"
          aria-controls="selected-fitlers"
        >
          Selected Filters
        </button>
      </h2>
      <div id="selected-fitlers" className="accordion-collapse collapse show" data-bs-parent="#selectedfilterAccordion">
        <div className="accordion-body">
          <div className="selectedFilter-wrapper">
            {isValidArray(categoryMenu) && (
              <Fragment>
                <div className="selected-filters">
                  <h6 className="fw-bold">Category:</h6>
                  <div className="selected-filtersList">
                    {categoryDataAll &&
                      categoryMenu.map((refines, index) => (
                        <div key={refines.label} className="selectedFilters">
                          <p>{refines.label}</p>
                          <i
                            className="fa-solid fa-xmark"
                            data-value={refines.value}
                            onClick={() => {
                              if (index === 0) navigate(PAGES.HOME);
                              else {
                                handleRemoveCategory(refines.value);
                                categoryRefine(refines.value);
                              }
                            }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </Fragment>
            )}

            {isValidArray(refinements) ? (
              <Fragment>
                {refinements.map((item) => (
                  <Fragment key={item.label}>
                    <div className="selected-filters">
                      <h6 className="fw-bold" style={{ textTransform: "capitalize" }}>
                        {item.label}:{" "}
                      </h6>
                      <div className="selected-filtersList">
                        {isValidArray(item.refinements) &&
                          item.refinements.map((refines) => (
                            <div key={`${item.label}-${refines.value}`} className="selectedFilters">
                              <p>{refines.value}</p>
                              <i className="fa-solid fa-xmark" onClick={() => refine(refines)} />
                            </div>
                          ))}
                      </div>
                    </div>
                  </Fragment>
                ))}{" "}
              </Fragment>
            ) : (
              <div className="selected-filters" style={{ display: "none" }}>
                <h6>No filters applied</h6>
              </div>
            )}
            <ClearAllRefinement />
          </div>
        </div>
      </div>
    </div>
  );
};
